import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgStarActive = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 20, height: 19, viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M20 7.24L12.81 6.62L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27L16.18 19L14.55 11.97L20 7.24Z", fill: "#FFAE00" }) });
const ForwardRef = forwardRef(SvgStarActive);
export { ForwardRef as ReactComponent };
